module.exports = __webpack_public_path__ + "img/microsoft.b574d6ae.svg";